import Crud from '../views/Origins/Crud'
import Entity from '../views/Origins/Add'

let routes = {
    path: '/origins',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/origins/add',
            name: 'NewOrigin',
            component: Entity,
            meta: {
                pageTitle: 'Origins',
                access_level: ['1'],
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/origins'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/origins/edit/:id?',
            name: 'EditOrigin',
            component: Entity,
            meta: {
                pageTitle: 'Origins',
                access_level: ['1'],
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/origins'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/origins',
            name: 'list-origins',
            component: Crud,
            meta: {
                pageTitle: 'Origins',
                access_level: ['1'],
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
